import slice from './slice';

const pipelineReducer = slice.reducer;

export const { setFieldPipeline } = slice.actions;

export default pipelineReducer;
